import { useState, type FormEvent } from 'react';
import { APP } from '@kia/shared';
import { useAuth } from '../auth/AuthProvider';
import { Button, Field, Input } from '../ui';
import './login.css';

export function LoginScreen() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [mfaStep, setMfaStep] = useState(false);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setBusy(true);
    const result = await login(username.trim(), password, mfaStep ? otp.trim() : undefined);
    setBusy(false);
    if (result.ok) return;
    if (result.mfaRequired) {
      setMfaStep(true); // move to the second-factor prompt
      if (result.mfaInvalid) setError(result.message); // wrong code — keep them on the OTP step
      return;
    }
    setError(result.message);
  }

  return (
    <div className="login">
      <div className="card">
        <div className="brand-hero">
          <img className="mark" src="/assets/logo-mark.svg" alt={APP.company} />
          <h1>{APP.name}</h1>
          <div className="co">{APP.company}</div>
          <div className="tag">{APP.tagline}</div>
        </div>

        <form onSubmit={onSubmit}>
          {!mfaStep ? (
            <>
              <Field label="نام کاربری" htmlFor="lu">
                <Input
                  id="lu"
                  autoComplete="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  autoFocus
                />
              </Field>
              <Field label="گذرواژه" htmlFor="lp" error={error || undefined}>
                <Input
                  id="lp"
                  type="password"
                  autoComplete="current-password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </Field>
            </>
          ) : (
            <Field
              label="کد تأیید دومرحله‌ای"
              htmlFor="lotp"
              hint="کد ۶ رقمی از برنامهٔ احرازکننده، یا یک کد بازیابی"
              error={error || undefined}
            >
              <Input
                id="lotp"
                inputMode="numeric"
                autoComplete="one-time-code"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                autoFocus
              />
            </Field>
          )}
          <Button type="submit" block loading={busy} style={{ marginTop: 16 }}>
            {mfaStep ? 'تأیید' : 'ورود'}
          </Button>
        </form>

        <p className="note muted">
          اولین ورود: نام کاربری <b>admin</b> و گذرواژه <b>admin</b> (سپس در «کاربران» تغییر دهید).
        </p>
      </div>
    </div>
  );
}
